import { DataBaseModelInterface } from '@solcre-org/core';

export class ContactModel implements DataBaseModelInterface {
  constructor(
    public id?: number,
    public client?: number,
    public name?: string,
    public email?: string,
    public phone?: string,
    public isPrimary?: boolean,
    public position?: string,
    public isActive?: boolean
  ) {}

  public fromJSON(json: any): ContactModel {
    if (json) {
      this.id = json.id;
      this.client = json.client;
      this.name = json.name;
      this.email = json.email;
      this.phone = json.phone;
      this.isPrimary = json.isPrimary ?? false;
      this.position = json.position;
      this.isActive = json.isActive ?? false;
    }
    return this;
  }

  public fromJSONList(json: any): ContactModel[] {
    if (json) {
      return json.map((element: any) => new ContactModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      client: this.client,
      name: this.name,
      email: this.email,
      phone: this.phone,
      isPrimary: this.isPrimary ?? false,
      position: this.position,
      isActive: this.isActive ?? false,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.name ?? '';
  }
}